export default __webpack_public_path__ + "static/media/mountain_hamster_300.c115f8f7.webp";